import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { Button } from '@elements';
import { NotFoundContainer } from '@hocs/layouts/table-layout/table-layout.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/**
 * Table layout hoc component.
 *
 * @author Ihar Kazlouski
 * @function TableLayout
 * @category Hocs
 * @return {JSX.Element} wrapped component.
 */
var TableLayout = function TableLayout(_ref) {
  var isEmpty = _ref.isEmpty,
      handleAdd = _ref.handleAdd,
      handleUpload = _ref.handleUpload,
      title = _ref.title,
      emptyTitle = _ref.emptyTitle,
      addTitle = _ref.addTitle,
      children = _ref.children;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(_Fragment, {
    children: isEmpty ? /*#__PURE__*/_jsxs(NotFoundContainer, {
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        fontWeight: "bold",
        color: "mineShaft",
        children: title
      }), /*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        flexDirection: "column",
        children: /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            color: "comet",
            children: emptyTitle
          }), /*#__PURE__*/_jsxs(Box, {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            mt: 5,
            width: "300px",
            gap: 3,
            children: [handleUpload && /*#__PURE__*/_jsx(Button, {
              variant: "outlined",
              fullWidth: true,
              onClick: handleUpload,
              children: t('components.table.upload')
            }), handleAdd && /*#__PURE__*/_jsx(Button, {
              variant: "contained",
              fullWidth: true,
              onClick: handleAdd,
              children: addTitle
            })]
          })]
        })
      })]
    }) : children
  });
};

export { TableLayout };